import { LinearProgress } from "@mui/material"
import { NexTabPanel } from "../../components/Tab/NexTabs"
import { ReviewDrawerTab } from "../../models/MissionReview"
import { canSplitReview } from "../../utils/MissionReviewUtils"
import { useMissionReviewStore } from "../../zstore/MissionReviewStore"
import { ReviewDrawerFlightlineDetails } from "./ReviewDrawerFlightlineDetails"
import { ReviewDrawerSplit } from "./ReviewDrawerSplit"

export const ReviewEventDrawer = ({ tab }: { tab: ReviewDrawerTab }) => {
    const selectedReviews = useMissionReviewStore((state) => state.currentPartialLines) ?? []
    const firstReview = selectedReviews[0]

    if (!selectedReviews.length) {
        return <LinearProgress />
    }

    return (
        <>
            {canSplitReview(firstReview) && (
                <NexTabPanel index={ReviewDrawerTab.SPLIT} value={tab}>
                    <ReviewDrawerSplit />
                </NexTabPanel>
            )}
            <NexTabPanel index={ReviewDrawerTab.DETAILS} value={tab}>
                <ReviewDrawerFlightlineDetails review={firstReview} />
            </NexTabPanel>
        </>
    )
}
